// extracted by mini-css-extract-plugin
module.exports = {"card":"_e0b001a","link":"_25c7e2e"};